// @ts-check

import { useCallback } from "react";
import { useOrgConfigForTenant } from "./useOrgConfigForTenant";

/**
 * Hook for managing tenant feature flags config.
 */
export const useOrgFeatureFlagsForTenant = () => {
  const { loading, config, update, updating } = useOrgConfigForTenant();

  const updateFeatureFlags = useCallback(
    /**
     * @param {org_config.tenant.FeatureFlags} newFeatureFlags
     * @returns {Promise<boolean>}
     */
    async (newFeatureFlags) => {
      return update({
        featureFlags: newFeatureFlags,
      });
    },
    [update]
  );

  return {
    loading,
    featureFlags: config?.featureFlags,
    update: updateFeatureFlags,
    updating,
  };
};
